import { formatNumberToLocale } from "./formatNumberToLocale";

/**
 * Format USD
 * @param value
 * @returns string
 */
export const formatUsd = (value: number, minimumFractionDigits = 2, maximumFractionDigits = 2) =>
  `$${formatNumberToLocale(value, minimumFractionDigits, maximumFractionDigits)}`;
